import styled from 'styled-components';
import { Button, useToast } from '@/ui';
import { useCreatorsHub } from '@/hooks';
import { HubIdentity } from '../HubIdentity';

const HeadRow = styled.div` display: flex; justify-content: flex-end; margin-bottom: 12px; `;
const List = styled.div` display: flex; flex-direction: column; gap: 12px; `;
const Card = styled.article`
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.color.glassBg};
  padding: 14px;
`;
const Title = styled.h3` margin: 10px 0 4px; font-size: ${({ theme }) => theme.fontSize.md}; color: ${({ theme }) => theme.color.textPrimary}; `;
const Need = styled.p` margin: 0 0 8px; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted}; `;
const Tags = styled.div` display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 10px; `;
const Tag = styled.span` font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.accentCyan}; border: 1px solid ${({ theme }) => theme.color.glassBorder}; border-radius: ${({ theme }) => theme.radius.sm}; padding: 1px 8px; `;
const Foot = styled.div` display: flex; align-items: center; gap: 12px; `;
const Count = styled.span` font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.textMuted}; `;

export function CollaborationsTab() {
  const { collaborations, toggleInterest } = useCreatorsHub();
  const toast = useToast();
  return (
    <div>
      <HeadRow>
        <Button variant="secondary" onClick={() => toast('Posting collabs is coming soon')}>+ Post a collab</Button>
      </HeadRow>
      <List>
        {collaborations.map((c) => (
          <Card key={c.id}>
            <HubIdentity name={c.name} handle={c.handle} av={c.av} />
            <Title>{c.title}</Title>
            <Need>{c.need}</Need>
            <Tags>{c.tags.map((t) => <Tag key={t}>{t}</Tag>)}</Tags>
            <Foot>
              <Button
                variant={c.youInterested ? 'primary' : 'secondary'}
                onClick={() => void toggleInterest(c.id)}
              >
                {c.youInterested ? 'Interested ✓' : "I'm interested"}
              </Button>
              <Count>{c.interested} interested</Count>
            </Foot>
          </Card>
        ))}
      </List>
    </div>
  );
}
